// Every browser sign-in starts at the ROUTER's /auth/login (nobgp/nobgp-router#339,
// #1668): the app, a protected service and the router's own pages share one entry.
// The router binds the login to this browser (its nonce) before AuthKit sees it,
// which is what lets its callback refuse an attacker's code. The app used to start
// logins with the AuthKit SDK, which reached the router's callback unbound.
export type RouterLoginOptions = {
  // Where the router sends the browser, with the tokens in the fragment.
  returnTo: string
  loginHint?: string
  organizationId?: string
  // AuthKit's sign-up screen instead of its sign-in screen.
  signUp?: boolean
  // Straight to Google, with no hosted page first.
  google?: boolean
}

export function routerLoginURL(routerBaseURL: string, o: RouterLoginOptions): string {
  const q = new URLSearchParams({ returnTo: o.returnTo })
  if (o.loginHint) q.set('login_hint', o.loginHint)
  if (o.organizationId) q.set('organization_id', o.organizationId)
  if (o.signUp) q.set('screen_hint', 'sign-up')
  if (o.google) q.set('provider', 'google')
  return `${routerBaseURL.replace(/\/+$/, '')}/auth/login?${q.toString()}`
}
